import React, { useState, useEffect, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useNavigate, useLocation } from 'react-router-dom';
import StoredUserContext from '../../context/StoredUserContext';
import './Menu.scss'
// import { connect } from 'react-redux';
// import { Logout } from '../../redux/actions';
// import { googleLogout } from '@react-oauth/google';
import {
  MessageFilled,
  ClockCircleFilled,
  CopyFilled,
  ScheduleFilled,
  UsergroupAddOutlined,
  SettingOutlined,
  MenuOutlined
} from '@ant-design/icons';


function Menu() {
  const navigate = useNavigate();
  const location = useLocation();

  const [showMenu, setShowMenu] = useState(false);
  const [loginAccount, setLoginAccount] = useState({account:"test"}) 
  const [activeMenu, setActiveMenu] = useState('');
  const user = JSON.parse(localStorage.getItem('user'));
  const [contextUser, setContextUser] = useContext(StoredUserContext);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleRoute = (route) => {
    navigate(`/${route}`);
  }

  const handleLogout = () => {
    if(window.confirm("Are you sure you want to logout?")){
      setLoginAccount({})
      // googleLogout();
      // Logout();
      setContextUser(null);
      localStorage.removeItem('user')
    }
    navigate("/login")
  }

  useEffect(() => {
    // 根据当前路由来判断哪个菜单项应该高亮
    const currentPath = location.pathname;
    if (currentPath === '/home') {
      setActiveMenu('home');
    } else if (currentPath === '/chat-history') {
      setActiveMenu('chat-history');
    } else if (currentPath === '/my-documents') {
      setActiveMenu('my-documents');
    } else if (currentPath === '/my-schedule') {
      setActiveMenu('my-schedule');
    } else if (currentPath === '/contact-us') {
      setActiveMenu('contact-us');
    } else if (currentPath === '/setting') {
      setActiveMenu('setting');
    } else {
      setActiveMenu(''); // 如果没有匹配的路由，取消高亮所有菜单项
    }
  }, [location.pathname]); // 当路由变化时触发

  return (
      <div className='d-flex justify-content-between'>
      <Button className='menu-toggle' onClick={toggleMenu}>
        <MenuOutlined className='menu-toggle-icon'/>
      </Button> 
      <Modal id="menu-modal" show={showMenu} onHide={toggleMenu} centered dialogClassName="menu-modal left-aligned-modal">
        <Modal.Body>
          <div className='d-flex flex-column justify-content-between' style={{height:"90vh"}}>
            <div className='d-flex justify-content-between'>
              <button className='menu-logo-box d-flex align-items-center col-6' onClick={()=>{handleRoute('pre-home')}}>
                  <img 
                  className='menu-logo'
                  src={user && user.avatar_url ? user.avatar_url : require('../../assets/images/logo.png')} 
                  alt='' />
              </button>
              <div className='h-100 d-flex align-items-center col-6 justify-content-center menu-logo-welcome'>
                Welcome, {user && user.user_name ? user.user_name : 'Unkown user'}
              </div>
            </div>
            <div className='d-flex flex-column menu-items'>
                <button className={ location.pathname === '/home'?'menu-button-active':'menu-button'} onClick={()=>{handleRoute('home')}}>
                  <div className='menu-button-icon'><MessageFilled style={{color: "#fff"}}/></div>
                  New Chat
                </button>
                <button className={ location.pathname === '/chat-history'?'menu-button-active':'menu-button'} onClick={()=>{handleRoute('chat-history')}}>
                  <div className='menu-button-icon'><ClockCircleFilled style={{color: "#fff"}}/></div>
                  Chat History
                </button>
                <button className={ location.pathname === '/my-documents'?'menu-button-active':'menu-button'} onClick={()=>{handleRoute('my-documents')}}>
                  <div className='menu-button-icon'><CopyFilled style={{color: "#fff"}}/></div>
                  My Documents
                </button>
                <button className={ location.pathname === '/my-schedule'?'menu-button-active':'menu-button'} onClick={()=>{handleRoute('my-schedule')}}>
                  <div className='menu-button-icon'><ScheduleFilled style={{color: "#fff"}}/></div>
                  My Schedule
                </button>
                <button className={ location.pathname === '/contact-us'?'menu-button-active':'menu-button'} onClick={()=>{handleRoute('contact-us')}}>
                  <div className='menu-button-icon'><UsergroupAddOutlined style={{color: "#fff"}}/></div>
                  Contact Us
                </button>
                <button className={ location.pathname === '/setting'?'menu-button-active':'menu-button'} onClick={()=>{handleRoute('setting')}}>
                  <div className='menu-button-icon'><SettingOutlined style={{color: "#fff"}} /></div>
                  Settings
                </button>
                <button className={ location.pathname === '/sharing'?'menu-button-active':'menu-button'} onClick={()=>{handleRoute('sharing')}}>
                  <div className='menu-button-icon'><SettingOutlined style={{color: "#fff"}} /></div>
                  Sharing
                </button>
            </div>
            <div className='menu-login-box d-flex flex-column menu-auth'>
            {
            loginAccount && loginAccount.account && loginAccount.account !== ''
            ?
            <button className='menu-logout-button' onClick={handleLogout}>Logout</button>
            :
            <button className='menu-login-button' onClick={()=>{handleRoute('login')}}>Login</button>
            }
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default (Menu);